<template>
  <vue-scroll :ops="ops" ref="vs" @handle-scroll="handleScroll">
  <div class="Con">
<!--    导航栏-->


<!--    轮播图-->
    <div class="banner" id="d1">
      <first-Component  class="header" :class="{active:!isShowNav}"  style="position: absolute;top:0;z-index: 999;background-color: white;" :num=1 ></first-Component>

      <first-Component class="animated bounceInDown" style="position: fixed;
    z-index: 999999;
    background-color: white;animation-duration:3s;" :num=1  v-if="!isShowNav"></first-Component>



      <el-carousel height="100vh"  arrow="always">
        <el-carousel-item v-for="(item,index) in imgPath" :key="index">
          <div class="text animated fadeInLeft" v-if="index===0">
<!--            <span>NISSAN FIVE-HOLE ANTI-PINCH MOTOR</span>-->
            <span>{{$t('bannerText[0].one')}}</span>
            <p class="bigText">{{$t('bannerText[0].two')}}</p>
            <p class="smallText">{{$t('bannerText[0].three')}}</p>
          </div>
          <div class="text" v-else-if="index===1">
            <span style="text-transform: uppercase">{{$t('bannerText[1].one')}}</span>
            <p class="bigText" style="text-transform: capitalize">{{$t('bannerText[1].two')}}</p>
<!--            <p class="smallText">Committed to providing customers with high quality and efficien</p>-->
          </div>
          <div class="text" v-else>
            <span style="text-transform: uppercase">{{$t('bannerText[2].one')}}</span>
            <p class="bigText" style="text-transform: capitalize">{{$t('bannerText[2].two')}}</p>
            <p class="smallText">{{$t('bannerText[2].three')}}</p>
          </div>

          <img  v-lazy="`http://www.nbbinyu.com/upload/${item.PICURL}`">
        </el-carousel-item>
      </el-carousel>
    </div>


    <div class="title wow fadeInUp " >
      <p>{{$t('home[0]')}}</p>
      <div class="three">
      <span style="left: 0"></span>
        <img src="../assets/d.png" alt="">
        <span style="right: 0;"></span>
      </div>

    </div>

    <div class="fiveNav wow fadeInUp">
      <ul>
        <li v-for="(item,index) in proList" @click="gotProduct(index,item.ID)" :key="index">
          <span :style="num===index?colorStyle:''">{{item.CALLED}}</span>
          <span  class="line" :style="num===index?showStyle:''"></span>
        </li>
      </ul>


    </div>

    <div class="productCon wow fadeInUp">

      <el-carousel style="width: 100%;" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="(item,index) in productList" :key="index" >
          <div class="fourImg" >
            <div class="item" v-for="i in item" @click="gotoProductInfo(i.ID)" >
              <img :src="`http://www.nbbinyu.com/upload/${i.SMALLPIC}`" alt="">
              <div class="twoText">
                <span>{{i.PRONAME}}</span>
                <span>{{i.TITLE2}}</span>
              </div>
              <div class="fourLine">
                <div class="anim-border">
                  <s class="oneLine loc_l"></s>
                  <s class="oneLine loc_r"></s>
                  <s class="oneLine loc_t"></s>
                  <s class="oneLine loc_b"></s>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <span class="btn" @click="gotoMore">{{$t('btn')}}</span>


    </div>

    <div class="title wow fadeInUp">
      <p>{{$t('home[1]')}}</p>
      <div class="three">
        <span style="left: 0"></span>
        <img src="../assets/d.png" alt="">
        <span style="right: 0;"></span>
      </div>

    </div>

    <div class="about wow fadeInUp">
      <div class="left">
       <div class="leftTitle">
       <span>{{$t('TitleList[0]')}}</span>
         <span class="b">{{$t('TitleList[1]')}} </span>
         <span class="c">{{$t('TitleList[2]')}}</span>
         <span>{{$t('TitleList[3]')}}</span>
       </div>
        <p style="font-family: light">
       {{$t('intro')}}
        </p>
        <div class="button">
          <span class="btn btnImg" @mouseenter="showImg" @mouseleave="isshowImg=true">
            <a href="https://www.amazon.com/shops/BYMOTOR" target="_blank" v-if="isshowImg">
              <img src="../assets/ya.svg" alt="" >
            </a>
            <a href="https://www.amazon.com/shops/BYMOTOR" target="_blank" v-else>    <img src="../assets/ym2.svg" ></a>

        </span>
          <span class="btn" @click="gotoAbout">
          {{$t('btn')}}
        </span>
        </div>

      </div>
      <img src="../assets/about.png" alt="">

    </div>

    <div class="te wow fadeInUp">
      <img src="../assets/te.png">
      <div class="content">
        <p>{{$t('home[2]')}}</p>
        <p>{{$t('teIntro[0]')}}</p>
        <p>{{$t('teIntro[1]')}}</p>
      </div>
      <div class="threeBtn">
        <span @click="gotoTe(0)">{{$t('teList[0]')}}</span>
        <span @click="gotoTe(1)">{{$t('teList[1]')}}</span>
        <span @click="gotoTe(2)">{{$t('teList[2]')}}</span>
      </div>
    </div>
    <div class="map wow fadeInUp">
      <div class="title">
        <p>{{$t('home[3]')}}</p>
        <div class="three">
          <span style="left: 0"></span>
          <img src="../assets/d.png" alt="">
          <span style="right: 0;"></span>
        </div>
      </div>

      <map-Component class="mapA"></map-Component>
      <img src="../assets/mapm.png" alt="" class="mapB">
      <span class="btn" @click="gotoMark">{{$t('btn')}}</span>
    </div>
    <foot-Component class="wow fadeInUp" @gotoTop="gotoTop"></foot-Component>
    </div>


  </vue-scroll>
</template>

<script>
  import { setup } from "../local/index";
  import footComponent from './foot'
  import firstComponent from './first'
  import mapComponent from './map'
  import  {WOW} from 'wowjs'
  import { getPicUrl,getProductstypeUrl2,getProductsUrl } from '../util/lang'
export default {
  name: 'HelloWorld',
  data () {
    return {
      isshowImg:true,
      proID:1,
      num:0,
      proList:[],
      colorStyle:{color:'#C7000C'},
      showStyle:{display:'block'},
      isShowNav:true,
      productList:[],
      isShow:false,
      imgPath:[
      ],
      aStyle:{display:'none'},
      threeImg:[
        require("../assets/red.png"),
        require("../assets/email.png"),
        require("../assets/sousuo.png")
      ],
      ops: {
        vuescroll: {
          mode: 'native',
          sizeStrategy: 'percent',
          detectResize: true
        },
        scrollPanel: {
          speed: 300,
          scrollingX: false,
        },
        rail: {
          background: '#01a99a',
          opacity:0,
          size:'2px'
        },
        bar: {
          showDelay: 500,
          background: '#0C3665',
            size: '2px',
        }
      },
      wow:''
    }
  },
  components:{
    footComponent,
    firstComponent,
    mapComponent
  },
  mounted(){
    this.wow=new WOW();
    this.wow.init()
    this.$nextTick(()=>{
      this.getList()
      this.getPro()
      if(this.$i18n.locale==='en'){
        this.getProduct('25')
      }else{
        this.getProduct('87')
      }
    })
  },
  methods:{
    gotoTop(){
      this.$refs['vs'].scrollIntoView('#d1', 500);
    },
    showImg(){
      this.isshowImg=false
    },
    gotoProductInfo(id){
      this.$router.push({path:'/productInfo',query:{id:id}})
    },
    getProduct(id){
      this.$nextTick(()=>{
        const url = `${getProductsUrl( this.$i18n.locale,id,100,1)}`
        this.$axios.get(url).then(res => {
          let arr=[]
          res.data.proarr.map((item)=>{
            if(item.ISCOMMEND=='1'){
              arr.push(item)
            }
          })
          for(let i=0;i<arr.length;i+=4){
            this.productList.push(arr.slice(i,i+4));
          }
        })
      })
    },
      getPro(){
    this.$nextTick(()=>{
      const url = `${getProductstypeUrl2( this.$i18n.locale)}`
      this.$axios.get(url).then(res => {
        this.proList=res.data.slice(1,6)
      })
    })
  },
    getList(){
      this.$nextTick(()=>{
        const url = `${getPicUrl( 'zh-CN','首页banner',17)}`
        this.$axios.get(url).then(res => {
        this.imgPath=res.data
        })
      })
    },
    gotoMore(){
      if(this.proID==1){
        this.$router.push({path:'/product',query:{select:this.num,id:this.proList[0].ID}})
      }else{
        this.$router.push({path:'/product',query:{select:this.num,id:this.proID}})
      }
    },
    gotProduct(index,id){
      this.num=index
      this.productList=[]
      this.getProduct(id)
      this.proID=id
    },
    gotoAbout(){
      this.$router.push({path:'/about'})
    },
    gotoMark(){
      this.$router.push({path:'/market'})
    },
    gotoTe(index){
      this.$router.push({path:'/tech',query:{select:index}})
    },
    handleScroll(vertical, horizontal, nativeEvent) {
      let top=vertical.scrollTop
     if(top>0){
      this.isShowNav=false
     }else{
       this.isShowNav=true
     }
      window.pageYOffset=top
     this.wow.scrollHandler()
    },
    noShow(){
      this.isShow=false
    },
    showKey(){
      this.isShow=true
    },
    change(){
      this.$i18n.locale = 'cn'
      window.localStorage.setItem('language', 'cn')
      setup('cn');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .header{
    transition: 1s;
    &.active{
      transform: translateY(-100%);
    }
  }
.Con{
  width:100%;
  .banner{
    width:100%;
    position: relative;
    .text{
      position: absolute;
      top:40%;
      left: 10%;
      color:white;
      span{
        font-size: 35px;
        display: inline-block;
        border-bottom: 2px solid rgba(255,255,255,.2);
        padding-bottom: 30px;
        position: relative;
      }
      .bigText{
        font-size: 26px;
        font-weight: bold;
        margin-top: 50px;
      }
    }
    img{
      height:100vh;
      width:100%;
      cursor: pointer;
      object-fit: cover;
    }
  }
    .title{
      width:100%;
      text-align: center;
      margin-top: 60px;
      padding-bottom: 60px;
      p{
        font-size: 24px;
        font-weight: bold;
        color:#0C3665;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
  }
  .fiveNav{
    width:1280px;
    margin: 0 auto;
    height:80px;
    ul{
      width:100%;
      list-style: none;
      margin-top: 0;
      padding-inline-start: 0px;
   display: flex;
      flex-direction: row;
      justify-content: space-between;
      li{
        color:#0C3665;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        transition:color 2s;
        -webkit-transition:color 2s ;
        line-height: 50px;
        position: relative;
        text-transform: uppercase;
        .line{
          position: absolute;
          bottom: 0;
          display: none;
          height:2px;
          width:0;
          left: -5%;
          background-color: #C7000C;
          animation:mymove 600ms;;
          /*Safari 和 Chrome*/
          -webkit-animation:mymove 600ms ;
          animation-fill-mode: forwards;
        }
        .productItem{
          position: absolute;
          top:100%;
          background-color: white;
          flex-direction: column;
          display: none;
          z-index: 9999;
          a{
            font-size: 14px;
            transition:color 1s;
            -webkit-transition:color 1s ;
            font-weight: bold;
          }
          a:hover{
            color:#C7000C;
          }
        }
        .productItem::before{
          width: 10000px;
          position: absolute;
          top:0;
          height: 100%;
          background:white;
          content: '';
          visibility: visible;
          opacity: 1;
          transition: all .5s;
          left:100%;
          z-index: 9999;
        }
        .productItem::after{
          width: 10000px;
          position: absolute;
          top: 0;
          height: 100%;
          background: white;
          content: '';
          visibility: hidden;
          opacity: 1;
          transition: all .5s;
          right:100%;
          z-index: 9999;
        }
        @keyframes myMove {
          from {width:0;}
          to {width:120%;}
        }
        @-webkit-keyframes mymove /*Safari 和 Chrome*/
        {
          from {width:0;}
          to {width:120%;}
        }
      }
      li:hover,li:hover .line{
        color:#C7000C;
        display: block;
      }
      li:hover .productItem, li:hover .productItem::after{
        display: flex;
        visibility: visible;
      }
    }
  }
  .productCon{
    width:1280px;
    margin: 40px auto;
    display: flex;
    flex-direction: column;
    .fourImg{
      width:95%;
      display: flex;
      flex-direction: row;
      margin-left: 2.5%;
      padding-left: 5%;
      .item{
        width:20%;
        height:300px;
        margin-left: 2%;
        position: relative;
        cursor: pointer;
        img{
          position: absolute;
          width:80%;
          margin-left: 10%;
          margin-top: 10%;
          height:200px;
          cursor: pointer;
          transition: all 1s;
          z-index: 999;
          object-fit: contain;
        }
        img:hover{
          transform: scale(1.1);
        }
        .twoText{
          position: absolute;
          bottom: 2%;
          display: flex;
          flex-direction: column;
          text-align: center;
          width:100%;
          span{
            margin-top: 10px;
          }
          span:first-child{
            color:#0C3665;
            font-weight: bold;
            font-size: 20px;
          }
          span:last-child{
            color:#9F9F9F;
            font-size: 14px;
            font-family: light;
          }
        }
        .fourLine{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          .anim-border{
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            position: relative;
                .loc_l{
                  bottom: 0;
                  left: 0;
                  width: 1px;
                  height: 0;
                }
                .loc_r{
                  top: 0;
                  right: 0;
                  width: 1px;
                  height: 0;
                }
                .loc_t{
                  top: 0;
                  left: 0;
                  width: 0;
                  height: 1px;
                }
                .loc_b{
                  bottom: 0;
                  right: 0;
                  width: 0;
                  height: 1px;
                }
              .oneLine{
                background-color: #cf3120;
                position: absolute;
                -webkit-transition: width .8s,height .8s,top .8s;
                transition: width .8s,height .8s,top .8s;
              }
          }
        }
      }
      .item:hover .fourLine .anim-border .loc_l{
        height:100%;
      }
      .item:hover .fourLine .anim-border .loc_r{
        height:100%;
      }
      .item:hover .fourLine .anim-border .loc_t{
        width:100%;
      }
      .item:hover .fourLine .anim-border .loc_b{
        width:100%;
      }
    }
    .btn{
      font-weight: bold;
      margin: 30px auto;
      display: inline-block;
      color:#C7000C;
      padding: 8px 2%;
      font-size: 12px;
      border: 1px solid #0C3665;
      -webkit-border-radius: 60px / 60px;
      -moz-border-radius: 60px / 60px;
      border-radius: 60px / 60px;
      cursor: pointer;
      background: linear-gradient(to top, #0C3665,#0C3665) no-repeat;
      background-size: 100% 0%;
      text-transform: uppercase;
      -webkit-transition: all .5s;
      transition: all .5s;
    }
    .btn:hover{
      background-size: 100% 100%;
      color: white;
    }
  }
  .about{
    width:1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    padding-bottom: 60px;
    .left{
      display: flex;
      flex-direction: column;
      width:40%;
      margin-left: 10%;
      position: relative;
      .leftTitle{
        width:100%;
        font-size: 25px;
        font-weight: bold;
        .b{
          color:#C7000C;
        }
        .c{
          color:#0C3665;
        }
      }
      p{
        line-height: 40px;
        margin-block-end: 0em;
      }
     .button{
       width:100%;
       position: relative;
       .btn{
         margin: 30px auto;
         display: inline-block;
         position: absolute;
         right:5%;
         color:#C7000C;
         padding: 9px 3%;
         font-size: 12px;
         border: 1px solid #0C3665;
         -webkit-border-radius: 60px / 60px;
         -moz-border-radius: 60px / 60px;
         border-radius: 60px / 60px;
         cursor: pointer;
         font-weight: bold;
         background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
       background-size: 100% 0%;
       text-transform: uppercase;
       -webkit-transition: all .5s;
       transition: all .5s;
     }
       .btn:hover{
         background-size: 100% 100%;
         color: white;
       }
       .btnImg{
         right:30%;
         color:#0C3665;
         padding: 0px 25px;
         padding-top: 5px;
         img{
           height:25px;
           width:60px;
         }
       }
     }
    }
    img{
      width:40%;
      margin-left: 5%;
      transition: all 1s;
      cursor: pointer;
    }
    img:hover{
      transform: scale(1.1); /* 放大1.2倍 */
    }
  }
  .te{
    width:100%;
    position: relative;
    margin-top: 60px;
    img{
   height:100%;
      width:100%;
      display: block;
    }
    .content{
      display: flex;
      flex-direction: column;
      position: absolute;
      left: 11%;
      top:40%;
      p{
        color:white;
      }
      p:first-child{
        font-size: 35px;
        font-weight: bold;
      }
    }
    .threeBtn{
      width:100%;
      color:white;
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      span{
        display: inline-block;
        width:20%;
        color:#0C3665;
        padding:15px 10px;
        -webkit-border-radius: 60px / 50px;
        -moz-border-radius: 60px / 50px;
        border-radius: 60px / 50px;
        text-align: center;
        margin-left: 2%;
        font-weight: bold;
        cursor: pointer;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        background-color:rgba(255,255,255,0.9);
      }
      span:hover{
        background-size: 100% 100%;
        color:white;
      }
    }
  }
  .map{
    width:100%;
    background-color:#FAFAFA;
    padding-top: 60px;
    text-align: center;
    padding-bottom: 60px;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      margin-top: 0;
      p{
        font-size: 24px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
        margin-block-end: 1em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .btn{
      display: inline-block;
      color:#C7000C;
      padding: 8px 3%;
      font-size: 12px;
      border: 1px solid #0C3665;
      -webkit-border-radius: 60px / 50px;
      -moz-border-radius: 60px / 50px;
      border-radius: 60px / 50px;
      cursor: pointer;
      font-weight: bold;
      background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
      background-size: 100% 0%;
      text-transform: uppercase;
      -webkit-transition: all .5s;
      transition: all .5s;
    }
    .btn:hover{
      background-size: 100% 100%;
      color: white;
    }
    .mapB{
      display: none;
    }
  }
  .div1{
    width:100px;
    height:100px;
   border: 1px solid black;
    margin: 0 auto;
    z-index: 999;
  }
  @media screen and (max-width:768px){
    .fiveNav{
      width:100%;
      ul{
        width:90%;
        margin-left: 5%;
      }
    }
    .productCon{
      width:100%;
      .fourImg{
        .item{
          height:200px;
        }
      }
    }
    .about{
      width:100%;
    }
    .te{
      .content{
        top:-4%;
      }
    }
  }
  @media screen and (max-width:450px){
    .banner{
      .text{
        left:5%;
        span{
          font-size: 25px;
        }
        .bigText{
          font-size: 15px;
        }
      }
    }
    .fiveNav{
      ul{
        li{
          height:50px;
          font-size: 12px;
          overflow: hidden;
        }
      }
    }
    .productCon{
      .fourImg{
        flex-wrap: wrap;
        .item{
          height:156px;
          width:45%;
          .twoText{
            span:first-child{
              font-size: 16px;
            }
          }
        }
      }
    }
    .about{
      display: flex;
      flex-direction: column;
      padding-bottom: 0;
      .left{
        width:90%;
        margin-left: 5%;
        text-align: center;
         padding-bottom: 80px;
        font-size: 14px;
        .leftTitle{
          font-size: 18px;
        }
        .button{
          width:100%;
          text-align: center;
          padding-bottom: 20px;
          .btnImg{
            right:60%;
          }
        }
      }
      img{
        width:100%;
        object-fit: cover;
        margin-left: 0;
      }
    }
    .te{
      .content{
        top:5%;
      }
      .threeBtn{
        flex-direction: column;
        position: static;
        padding-bottom: 30px;
        span{
          width:94%;
          font-size: 10px;
          padding: 10px 5px;
          margin-top: 10px;
          background-color:#FAFAFA;
        }
      }
      img{
        height:300px;
        object-fit: cover;
      }
    }
    .map{
      .mapA{
        display: none;
      }
      .mapB{
        display: block;
        object-fit: cover;
        width:100%;
        height:100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue